import React from 'react';

const Hood = () => (
  <path d="M21 12l4.2857 5H26c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1H6c-.5523 0-1-.4477-1-1v-6c0-.5523.4477-1 1-1h.7143L11 12V4c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1v8zm-2 0V5h-6v7h6zM7 19v4h18v-4H7zm5 3c-.5523 0-1-.4477-1-1s.4477-1 1-1 1 .4477 1 1-.4477 1-1 1zm4 0c-.5523 0-1-.4477-1-1s.4477-1 1-1 1 .4477 1 1-.4477 1-1 1zm4 0c-.5523 0-1-.4477-1-1s.4477-1 1-1 1 .4477 1 1-.4477 1-1 1zM9 17h13.3031l-2.5714-3h-8.1603L9 17z" />
);

export default Hood;
